module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'iqajt1ld',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
